import { Patient } from '@koi/components/DigitalForms/api/types/digitalForms.api.types';
import { formatDate } from '@koi/utils/dateFunctions';
import { formatDistanceToNowStrict, isValid } from 'date-fns';
import { useCallback } from 'react';

export const usePatientAge = () => {
  const getPatientAge = useCallback((patient: Pick<Patient, 'birthday' | 'deathDate' | 'wasEuthanized'>) => {
    return patient.deathDate
      ? patient.wasEuthanized
        ? 'Euthanized'
        : 'Deceased'
      : patient?.birthday && isValid(formatDate(patient.birthday))
        ? formatDistanceToNowStrict(formatDate(patient.birthday)).replace('year', 'yr').replace('month', 'mo')
        : undefined;
  }, []);

  return { getPatientAge };
};
